// import CryptoJS from "../../node_modules/crypto-js/crypto-js"
var CryptoJS = require("crypto-js");
// 登录des对称加密
var DES_KEY = '7w7qf1af7faq81r7'
var AES_KEY = 'a646a7f3wa57d7uk'

// 加密
// function encrypt( key , iv , data ){
//     if( typeof data === "object" ){
//         // 如果传入的data是json对象，先转义为json字符串
//         try {
//             data = JSON.stringify(data)
//         } catch (error) {
//             console.log("error:",error)
//         }
//     }
//      // 统一将传入的字符串转成UTF8编码
//     const dataHex = CryptoJS.enc.Utf8.parse( data ) // 需要加密的数据
//     const keyHex = CryptoJS.enc.Utf8.parse( key ) // 秘钥
//     const ivHex = CryptoJS.enc.Utf8.parse( iv ) // 偏移量
//     const encrypted = CryptoJS.AES.encrypt( dataHex , keyHex , {
//       iv: ivHex,
//       mode: CryptoJS.mode.CBC, // 加密模式
//       padding: CryptoJS.pad.Pkcs7
//     })
//     return encrypted.ciphertext.toString() //  返回加密后的值
// }

// // 解密
// function decrypt( key , iv , encryptedVal ) {
// 	/*
// 		传入的key和iv需要和加密时候传入的key一致  
// 	*/
// 	// 统一将传入的字符串转成UTF8编码
// 	let encryptedHexStr = CryptoJS.enc.Hex.parse( encryptedVal  );
// 	let srcs = CryptoJS.enc.Base64.stringify( encryptedHexStr );
// 	const keyHex = CryptoJS.enc.Utf8.parse( key ) // 秘钥
// 	const ivHex = CryptoJS.enc.Utf8.parse( iv ) // 偏移量
// 	let decrypt = CryptoJS.AES.decrypt( srcs , keyHex , {
// 		iv: ivHex, 
// 		mode: CryptoJS.mode.CBC, 
// 		padding: CryptoJS.pad.Pkcs7
// 	});
// 	return decrypt.toString( CryptoJS.enc.Utf8 ).toString();
// }


function encrypt(word) {
	let key = CryptoJS.enc.Utf8.parse(DES_KEY);
	let srcs = CryptoJS.enc.Utf8.parse(word);
	// 如果要用AES加密，就将下面这行DES改成AES 解密同理
	let encrypted = CryptoJS.DES.encrypt(srcs, key, {
		mode: CryptoJS.mode.ECB,
		padding: CryptoJS.pad.Pkcs7
	});
	return encrypted.toString();
}

function decrypt(word, keyStr) {
	var key = CryptoJS.enc.Utf8.parse(AES_KEY)
	var encryptedHexStr = CryptoJS.enc.Hex.parse(word);
	var srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);
	var decrypt = CryptoJS.AES.decrypt(srcs, key, {
		mode: CryptoJS.mode.ECB,
		padding: CryptoJS.pad.Pkcs7
	})
	return decrypt.toString(CryptoJS.enc.Utf8).toString();
}

module.exports = {
	encrypt,
	decrypt
}


// WEBPACK FOOTER //
// ./src/utils/des.js